// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"db23be3c","57":"ac1ba6c3","124":"d7735254","353":"496a5887","449":"3cad94d4","453":"87e45203","570":"c5d954a7","660":"dff304d2","697":"31498dcd","712":"aebca8d3","819":"58a17425","851":"0f34130a"}[chunkId] + ".chunk.js";
};